import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Helmet } from "react-helmet";
import { Grid, PageWrapper } from "components/Containers";
import PageTitle from "components/PageTitle";
import { ProfileAddButton, ProfileViewButton } from "components/Profile";
import { NetworkList, NetworkListControls } from "components/Network";
import { useNetworkControls } from "hooks";
import { ListsAddForm } from "components/Lists";
import { MissionInviteForm } from "components/Missions";

/**
 * Network
 */
const Network = () => {
  const intl = useIntl();
  const resultsPerPage = 50;
  const {
    advancedOptions,
    selectedProfile,
    showAddToListsForm,
    showInviteMissionForm,
    setShowAddToListsForm,
    setShowInviteMissionForm,
    filterMetadata,
    data,
    ...rest
  } = useNetworkControls({
    resultsPerPage,
  });

  return (
    <PageWrapper>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Network.Title" })}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle title={<FormattedMessage id="Network.H1" />} actionBar={<ProfileAddButton isModal />} />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <NetworkListControls formValues={filterMetadata} {...rest} />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <NetworkList
            isCardView={false}
            rowOptions={advancedOptions}
            resultsPerPage={resultsPerPage}
            profileModalActions={[ProfileViewButton]}
            data={data}
            {...rest}
          />
        </Grid.col>
      </Grid>
      {showAddToListsForm && (
        <ListsAddForm
          show={showAddToListsForm}
          profileId={selectedProfile?.id}
          onClose={() => setShowAddToListsForm(false)}
        />
      )}
      {showInviteMissionForm && (
        <MissionInviteForm
          show={showInviteMissionForm}
          profile={selectedProfile}
          onClose={() => setShowInviteMissionForm(false)}
        />
      )}
    </PageWrapper>
  );
};

export default Network;
